window.validator = {
    addValidation(errorResponse, that, alertError) {
        let errors = errorResponse.data.errors;

        if (errorResponse.status === 500) {
            alertError.style.display = 'block';
            alertError.innerHTML = 'Error send email.';
            return;
        }

        Object.keys(errors).forEach(function (key) {
            let elm = that.elements[key];
            let nextElement = elm.nextElementSibling;
            let nextNextElement = elm.parentElement.nextElementSibling;

            if (elm.name === 'g-recaptcha-response') {
                return;
            }

            elm.classList.add('is-invalid');

            if (elm.nodeName === 'SELECT') {
                elm.style.backgroundImage = 'none';
                elm.style.borderWidth = '1px';
                elm.style.borderStyle = 'solid';

                nextNextElement.innerHTML = errors[key][0];
                nextNextElement.style.display = 'block';
            } else if (elm.type === 'checkbox' && elm.checked === false) {
                nextElement.nextElementSibling.style.display = 'block';
            } else {
                nextElement.innerHTML = errors[key][0];
                nextElement.style.display = 'block';
            }

        });
    },

    checkValidation(that) {
        for (let i = 0; i < that.children.length; i++) {
            let elm = that.children[i];

            if (elm.classList.contains('form-group')) {
                for (j = 0; j < elm.childNodes.length; j++) {
                    let subElm = elm.childNodes[j];

                    if (subElm.className === 'select-box'
                        && subElm.children[0].nodeName === 'SELECT'
                        && parseInt(subElm.children[0].value) !== 0) {
                        subElm.children[0].style.border = 'none';
                    }

                    if (subElm.nodeName === 'INPUT' || subElm.nodeName === 'TEXTAREA') {
                        subElm.classList.remove('is-invalid');
                    }

                    if (subElm.className === 'invalid-feedback') {
                        subElm.style.display = 'none';
                    }
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/validator.js